import React from "react"
import Image from "gatsby-image"

export default ({ ...props }) => (
  <figure className="block leading-none relative">
    <Image {...props} />
    <div className="absolute inset-0 m-sm image-overlay md:m-md lg:m-lg"></div>
  </figure>
)
